import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { Plus } from "lucide-react";

export const OrderFormDialog = ({ open, onOpenChange, onNew, editing, form, setForm, error, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button
        data-testid="new-order-btn"
        onClick={onNew}
        className="bg-[#39678f] hover:bg-[#2c5272] text-white subtitle uppercase tracking-wider text-xs h-10"
      >
        <Plus className="w-4 h-4 mr-2" /> New order
      </Button>
    </DialogTrigger>
    <DialogContent className="border border-[#33424f]/30">
      <DialogHeader>
        <DialogTitle className="font-display text-2xl tracking-tight text-[#33424f]">
          {editing ? "Edit order" : "Create order"}
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Label className="text-[10px] uppercase tracking-[0.2em] text-[#50493b] subtitle block mb-2">
            Job / freezer number *
          </Label>
          <Input
            data-testid="order-job-number-input"
            value={form.job_number}
            onChange={(e) => setForm({ ...form, job_number: e.target.value })}
            className="border-[#33424f]/30"
            required
            disabled={!!editing}
          />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-[0.2em] text-[#50493b] subtitle block mb-2">
            Description *
          </Label>
          <Input
            data-testid="order-description-input"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            className="border-[#33424f]/30"
            required
          />
        </div>
        <label className="flex items-center gap-2 text-sm">
          <Checkbox
            checked={form.active}
            onCheckedChange={(v) => setForm({ ...form, active: !!v })}
            className="data-[state=checked]:bg-[#39678f] data-[state=checked]:border-[#39678f]"
          />
          Active
        </label>
        {error && (
          <div className="p-2 border border-[#b30035] bg-[#fbe4ea] text-[#7a0024] text-xs font-body">{error}</div>
        )}
        <DialogFooter>
          <Button
            data-testid="save-order-btn"
            type="submit"
            className="bg-[#39678f] hover:bg-[#2c5272] text-white subtitle uppercase tracking-wider text-xs"
          >
            {editing ? "Save" : "Create"}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
